import { configureStore } from "@reduxjs/toolkit";
import  {thunk}  from 'redux-thunk';
import userReducer from "./reducers/userReducer";
import qrReducer from "./reducers/qrReducer";
import commonReducer from "./reducers/commonReducer";
import dynamicBgColorReducer from "./reducers/dynamicQRContentReducer/dynamicBgColorReducer";
import socialReducer from "./reducers/dynamicQRContentReducer/socialReducer";
import businessReducer from "./reducers/dynamicQRContentReducer/businessReducer";
import addressReducer from "./reducers/dynamicQRContentReducer/addressReducer";
import feedbackReducer from "./reducers/dynamicQRContentReducer/feedbackReducer";
import imageReducer from "./reducers/dynamicQRContentReducer/imageReducer";
import menuReducer from "./reducers/dynamicQRContentReducer/menuReducer";
import appReducer from "./reducers/dynamicQRContentReducer/appReducer";
import profileReducer from "./reducers/dynamicQRContentReducer/profileReducer";
import couponReducer from "./reducers/dynamicQRContentReducer/couponReducer";
import videoReducer from "./reducers/dynamicQRContentReducer/videoReducer";
import pdfReducer from "./reducers/dynamicQRContentReducer/pdfReducer";
import musicReducer from "./reducers/dynamicQRContentReducer/musicReducer";
import eventReducer from "./reducers/dynamicQRContentReducer/eventReducer";
import websiteReducer from "./reducers/dynamicQRContentReducer/websiteReducer";
import multipleLinksReducer from "./reducers/dynamicQRContentReducer/multipleLinksReducer";
import paymentReducer from "./reducers/paymentReducer";
import smsReducer from "./reducers/staticQRContentReducer/smsReducer";
import emailReducer from "./reducers/staticQRContentReducer/emailReducer";
import staticWebsiteReducer from "./reducers/staticQRContentReducer/staticWebsiteReducer";
import textReducer from "./reducers/staticQRContentReducer/textReducer";
import whatsappReducer from "./reducers/staticQRContentReducer/whatsappReducer";
import wifiReducer from "./reducers/staticQRContentReducer/wifiReducer";
import vcardReducer from "./reducers/staticQRContentReducer/vcardReducer";
import callReducer from "./reducers/staticQRContentReducer/callReducer";
import bitcoinReducer from "./reducers/staticQRContentReducer/bitcoinReducer";
import paypalReducer from "./reducers/staticQRContentReducer/paypalReducer";
import adminReducer from "./reducers/adminReducer"; // Import the adminReducer

const store = configureStore({
  reducer: {
    user: userReducer,
    qr: qrReducer,
    common: commonReducer,
    dynamicBgColor: dynamicBgColorReducer,
    social: socialReducer,
    business: businessReducer,
    address: addressReducer,
    feedback: feedbackReducer,
    image: imageReducer,
    link: multipleLinksReducer,
    menu: menuReducer,
    app: appReducer,
    profile: profileReducer,
    coupon: couponReducer,
    video: videoReducer,
    pdf: pdfReducer,
    event: eventReducer,
    music: musicReducer,
    website: websiteReducer,
    payment: paymentReducer,
    sms: smsReducer,
    email: emailReducer,
    staticWebsite: staticWebsiteReducer,
    text: textReducer,
    whatsapp: whatsappReducer,
    wifi: wifiReducer,
    vcard: vcardReducer,
    call: callReducer,
    bitcoin: bitcoinReducer,
    paypal: paypalReducer,
    admin: adminReducer, // Add the adminReducer to the reducer object
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export default store;
